import React from 'react'
import Affyn from './affyn'
import Affyndetails from './affyndetails'
import Klima from './klima'
import KlimaDetails from './klimaDetails'

export default function Furthur_pages() {
  return (
    <div className='text-white'>
      <Affyn />
      <Affyndetails />
      {/* <Klima />
      <KlimaDetails /> */}
    </div>
  )
}
